import { ArrowLeftCircle, ArrowRightCircle, Save } from 'react-feather';
import { TextField, Button, FormControl, Grid, MenuItem } from '@mui/material';

import { CustomAutocomplete, LinearLoading } from 'common'

export const VehicleReceptionStep = ({ useFetchInit, readOnlyMode }) => {

    const {
        globalStates,
        Forms,
        FetchData,
        Actions
    } = useFetchInit

    const { stepApplilication } = globalStates

    const { FormScreen } = Forms
    const { formState, onInputChange, onSelectSearchChange } = FormScreen
    
    const { 
        fetchSpecificVehicleReception,
        fetchConsigningAuthorities,
        fetchTariff,
        fetchLocations
    } = FetchData
    const { loadingFetchSpecificVehicleReception } = fetchSpecificVehicleReception
    const { dataConsingningAuthories } = fetchConsigningAuthorities
    const { dataTariff } = fetchTariff
    const { dataLocations } = fetchLocations

    const {
        onSubmitForm,
        handleClickTariff,
        handleClickReturnStep,
        handleClickContinue
    } = Actions

    const isSaved = formState.idreception > 0
    
    return (
        <>
            
            <div className='h4 mt-1 mb-1'>
                {formState.idreception > 0
                    ? 'Actualizar Registro'
                    : 'Crear Registro'}
            </div>
            <div className="border-bottom border-dark"></div>
            {loadingFetchSpecificVehicleReception && ( <LinearLoading /> )}

            <div className="pt-2"></div>
            <form onSubmit={onSubmitForm}>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="idauthority">* Autoridad que consigna</label>
                            <CustomAutocomplete 
                                customId="idauthority"
                                customName="idauthority"
                                customValue={formState.idauthority}
                                customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idauthority', value: value.value }})}
                                customPlaceholder='Selecciona una opcion'
                                customOptions={
                                    dataConsingningAuthories.map(({ idauthority, nombre }) => ({
                                        value: idauthority,
                                        name: nombre
                                    }))
                                }
                                customDisableClearable={true}
                                customDisabled={readOnlyMode}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="jsonRate">* Tarifa</label>
                            <CustomAutocomplete 
                                customId="jsonRate"
                                customName="jsonRate"
                                customValue={formState.jsonRate}
                                customOnChange={(target, value) => handleClickTariff({ target: { name: 'jsonRate', value: value.value }})}
                                customPlaceholder='Selecciona una opcion'
                                customOptions={
                                    dataTariff.map(({ idrate, descripcion, costo }) => ({
                                        value: JSON.stringify({ idrate, costo}),
                                        name: `${descripcion}`
                                    }))
                                }
                                customDisableClearable={true}
                                customDisabled={readOnlyMode}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="info_rate">* Costo</label>
                            <TextField
                                id="info_rate"
                                name="info_rate"
                                value={formState.info_rate}
                                onChange={onInputChange}
                                // label='Marca'
                                size='small'
                                type="text"
                                variant="filled"
                                hiddenLabel
                                InputProps={{
                                    readOnly: true,
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <div className="pt-2"></div>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="vehicle_placa">Placa</label>
                            <TextField
                                id="vehicle_placa"
                                name="vehicle_placa"
                                value={formState.vehicle_placa}
                                onChange={onInputChange}
                                // label='Marca'
                                size='small'
                                type="text"
                                variant="outlined"
                                // hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="vehicle_marca">* Marca</label>
                            <TextField
                                id="vehicle_marca"
                                name="vehicle_marca"
                                value={formState.vehicle_marca}
                                onChange={onInputChange}
                                // label='Marca'
                                size='small'
                                type="text"
                                variant="outlined"
                                // hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="vehicle_linea">* Linea</label>
                            <TextField
                                id="vehicle_linea"
                                name="vehicle_linea"
                                value={formState.vehicle_linea}
                                onChange={onInputChange}
                                // label='Linea'
                                size='small'
                                type="text"
                                variant="outlined"
                                // hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <div className="pt-2"></div>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="vehicle_color">* Color</label>
                            <TextField
                                id="vehicle_color"
                                name="vehicle_color"
                                value={formState.vehicle_color}
                                onChange={onInputChange}
                                size='small'
                                type="text"
                                variant="outlined"
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="vehicle_modelo">Modelo</label>
                            <TextField
                                id="vehicle_modelo"
                                name="vehicle_modelo"
                                value={formState.vehicle_modelo}
                                onChange={onInputChange}
                                size='small'
                                type="text"
                                variant="outlined"
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="vehicle_chasis">Chasis</label>
                            <TextField
                                id="vehicle_chasis"
                                name="vehicle_chasis"
                                value={formState.vehicle_chasis}
                                onChange={onInputChange}
                                // label='Motor'
                                size='small'
                                type="text"
                                variant="outlined"
                                // hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <div className="pt-2"></div>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="vehicle_motor">Motor</label>
                            <TextField
                                id="vehicle_motor"
                                name="vehicle_motor"
                                value={formState.vehicle_motor}
                                onChange={onInputChange}
                                // label='Motor'
                                size='small'
                                type="text"
                                variant="outlined"
                                // hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="info_fecha_ingreso">* Fecha Ingreso</label>
                            <TextField
                                id="info_fecha_ingreso"
                                name="info_fecha_ingreso"
                                value={formState.info_fecha_ingreso}
                                onChange={onInputChange}
                                size='small'
                                type="date"
                                variant="outlined"
                                hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode || isSaved,
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="info_numero_diligencia">Numero diligencia</label>
                            <TextField
                                id="info_numero_diligencia"
                                name="info_numero_diligencia"
                                value={formState.info_numero_diligencia}
                                onChange={onInputChange}
                                label='Numero diligencia'
                                size='small'
                                type="text"
                                variant="outlined"
                                // hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                                // required
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <div className="pt-2"></div>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="info_numero_proceso">Numero proceso</label>
                            <TextField
                                id="info_numero_proceso"
                                name="info_numero_proceso"
                                value={formState.info_numero_proceso}
                                onChange={onInputChange}
                                label='Numero proceso'
                                size='small'
                                type="text"
                                variant="outlined"
                                // hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                                // required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="info_cliente">A nombre de:</label>
                            <TextField
                                id="info_cliente"
                                name="info_cliente"
                                value={formState.info_cliente}
                                onChange={onInputChange}
                                // label='Marca'
                                size='small'
                                type="text"
                                variant="outlined"
                                // hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="info_dpi">DPI:</label>
                            <TextField
                                id="info_dpi"
                                name="info_dpi"
                                value={formState.info_dpi}
                                onChange={onInputChange}
                                // label='Marca'
                                size='small'
                                type="number"
                                variant="outlined"
                                // hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <div className="pt-2"></div>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="idlocation">* Ubicación</label>
                            <CustomAutocomplete 
                                customId="idlocation"
                                customName="idlocation"
                                customValue={formState.idlocation}
                                customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idlocation', value: value.value }})}
                                customPlaceholder='Selecciona una opcion'
                                customOptions={
                                    dataLocations.map(({ idlocation, location_name }) => ({
                                        value: idlocation,
                                        name: location_name
                                    }))
                                }
                                customDisableClearable={true}
                                customDisabled={readOnlyMode}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="info_motivo_recepcion">* Motivo de recepción</label>
                            <TextField
                                id="info_motivo_recepcion"
                                name="info_motivo_recepcion"
                                value={formState.info_motivo_recepcion}
                                onChange={onInputChange}
                                // label='Marca'
                                size='small'
                                type="text"
                                variant="outlined"
                                // hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="info_tiene_llaves">* Tiene llaves</label>
                            <TextField
                                id="info_tiene_llaves"
                                name="info_tiene_llaves"
                                placeholder="Selecciona una opción"
                                value={formState.info_tiene_llaves}
                                onChange={onInputChange}
                                select
                                size="small"
                                variant="outlined"
                                // hiddenLabel
                                InputProps={{ readOnly: readOnlyMode }}
                            >
                                <MenuItem value=''>-- Selecciona una opción --</MenuItem>
                                <MenuItem value='SI'>SI</MenuItem>
                                <MenuItem value='NO'>NO</MenuItem>
                            </TextField>
                        </FormControl>
                    </Grid>
                </Grid>
                <div className="pt-2"></div>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormControl fullWidth>
                            <label htmlFor="info_observaciones">Observaciones</label>
                            <TextField
                                id="info_observaciones"
                                name="info_observaciones"
                                value={formState.info_observaciones}
                                onChange={onInputChange}
                                // label='Modelo'
                                size='small'
                                multiline
                                rows={3}
                                type="text"
                                variant="outlined"
                                // hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <div className="pt-4"></div>
                <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>
                    <Grid item xs={12}>
                        <div className="text-center">
                            {stepApplilication !== 0 && (
                                <Button 
                                    variant="contained"
                                    type="button"
                                    onClick={handleClickReturnStep} 
                                    sx={{ marginRight: 3, marginLeft: 1, background: "#ef8157" }}
                                >
                                    <ArrowLeftCircle/>
                                </Button>
                            )}
                            <Button
                                variant="contained"
                                type="submit"
                                disabled={readOnlyMode}
                                style={{ marginRight: 2, marginLeft: 2, background: "#4b4b4c" }}
                            >
                                <Save />
                            </Button>
                            &nbsp;
                            {(formState.idreception > 0 && stepApplilication === 0)&&(
                                <Button
                                    variant="contained"
                                    type="button"
                                    onClick={handleClickContinue}
                                    style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                >
                                    <ArrowRightCircle/>
                                </Button>
                            )}
                        </div>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}
